module.exports = __webpack_public_path__ + "img/multi-two-group-unpaired.44576d58.svg";